import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/dashboard/account/$userId/')({
    component: RouteComponent,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/dashboard/account/$userId/profile',
            params,
        });
    },
});

function RouteComponent() {
    return null;
}
